<template>
  <es-form :padding="{ padding: '1.15rem 1.15rem 0 1.15rem' }">
    <template #es-form>
      <div class="row removeUnderline">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">
              Match Option
            </label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="buttons has-addons">
                  <router-link
                    v-if="activeMatchOptions.length > 1"
                    :to="`/personId/matchOptions/${option.route}`"
                    v-for="(option, index) in activeMatchOptions"
                    :key="index"
                    class="button button--form"
                    replace
                    style="min-width: 100px"
                  >
                    {{ option.description }}
                  </router-link>
                  <label
                  v-if="activeMatchOptions.length = 1"
                  class="field"
                  v-for="(option, index) in activeMatchOptions"
                  :key="index"
                  style="padding-top: 5px; padding-left: 3px"
                  >
                    {{ option.description }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </es-form>
</template>

<script>
import EsForm from '@/components/EsForm.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsForm,
  },
  data() {
    return {
      matchOptions: [],
    };
  },
  created() {
    this.matchOptions = [
      {
        description: 'Upload File',
        code: 'FILE',
        route: 'upload',
        isHidden: this.hasModule('PRSID:MATCH:OPTIONS:UPLOADFILE'),
      },
      // TODO: Uncomment below to enable Individual Match (Enter Online)
      // {
      //   description: 'Individual Match',
      //   code: 'INDIV',
      //   route: 'individual',
      //   isHidden: this.hasModule('PRSID:MATCH:OPTIONS:INDIVIDUALMATCH'),
      // },
    ];
  },
  computed: {
    activeMatchOptions() {
      return this.matchOptions.filter(item => item.isHidden);
    },
  },
};
</script>

<style lang="sass" scoped>
  .content
    padding-bottom: 2rem
</style>
